import bookSyncService from '@/services/booksync'
import bookService from '@/services/book'
import fs from '@/services/fs'

const fetchBooks = async ({rootState, commit}) => {
  if (rootState.user.accessToken !== null) {
    const books = await bookSyncService.getUserBooks(rootState.user.accessToken)

    commit('SET_BOOKS', books)
  }
}

const fetchBook = async ({rootState, commit}, bookId) => {
  if (rootState.user.accessToken !== null) {
    const book = await bookService.getBook(rootState.user.accessToken, bookId)

    commit('SET_BOOK', book)
  }
}

const fetchTOC = async ({rootState, commit}, bookId) => {
  if (rootState.user.accessToken !== null) {
    const toc = await bookService.fetchTableOfContent(rootState.user.accessToken, bookId)

    commit('SET_BOOK_TOC', toc)
  }
}

const getSavedBooks = async ({rootState, commit}) => {
  if (rootState.user.accessToken !== null) {
    let books = []

    try {
      books = await fs.getSavedBooks()
    } catch (err) {
      // no books in store
      return
    }
    const savedBooks = books.map(sb => sb.path.replace('/books/', ''))

    commit('SET_SAVED_BOOKS', savedBooks)
  }
}

export default {
  fetchBooks,
  fetchBook,
  fetchTOC,
  getSavedBooks
}
